import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../../Util/Session/session.service';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SiteGeoMappingService {

  constructor( private http: HttpClient,
    private session: SessionService,) { }

  SiteGeoMapLoad(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `GetGeoMappingGrid/Select`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  SiteGeoMapInsertUpate(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `SiteGeoMappingParameter/InsertUpdate`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GETSiteWisQRcode(QRDetail: any) {
    return this.http.post<any>(environment.API_URL + `GETSiteWisQRcode/Details`,
      this.session.SetClass(QRDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_SiteGeoMapping_BlukInsert(QRDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteGeoMapping_BlukInsert/Update`,
      this.session.SetClass(QRDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_BranchGeoMapping_BlukInsert(QRDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_BranchGeoMapping_BlukInsert/Update`,
      this.session.SetClass(QRDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
